const BreakPoints = {
    xs: 320,
    sm: 600,
    md: 900,
    lg: 1160,
    xl: 1360,
    xxl: 1720,
};

export default BreakPoints;
